// extracted by mini-css-extract-plugin
module.exports = {"Card--Footer":"Footer_Card--Footer__gdALl"};